<template>
  <div class="fy-head__menu" :class="{'fy-head__menu_show':isShowMenu}">
        <div class="fy-head__menu__item" v-for="item in menuList" :key="item.name">
          <div @click="goOther(item.url)" class="fy-head__menu__item__link"><span>{{item.nameZh}} | </span>{{item.name}}</div>
        </div>
        <div class="fy-head__menu__item_logo">Fununit Design</div>
  </div>
</template>

<script>
import Vue from 'vue';
import {DrawerLayout} from 'vue-drawer-layout'
import menuBottom from '@/assets/menu-bottom.png'
Vue.component(DrawerLayout.name, DrawerLayout)
export default Vue.extend({
  props:{
    isShowMenu:{
      type:Boolean,
      default:false
    }
  },
  name:'top-head',
  data () {
    return {
      menuBottom,
      menuList:[
        {
          name:'简介',
          nameZh: 'PROFILF',
          url:'/profile',
        },
        {
          name:'项目',
          nameZh: 'PROJECTS',
          url:'/design',
        },
        {
          name:'招聘',
          nameZh: 'JOIN US ',
          url:'/join_us',
        },
        {
          name:'联系',
          nameZh: 'CONTACT US',
          url:'/contact_us',
        }
      ]
    }
  },
  methods:{
    goOther(url){
      if(url===this.$route.path){
        this.$router.go(0)
      }else{
        this.$router.push(url)
      }
    }
  }
})
</script>
